var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('CTRLACS-USR-03'))?_c('b-button',{staticClass:"mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.atualizarUsuario()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Atualizar Usuário\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }